window.BOX_BUILDER_SITE = window.BOX_BUILDER_SITE || {
  ads: {
    enabled: false,
    provider: 'placeholder',
    message: 'Ad space reserved for a future sponsor or approved ad network.'
  },
  analytics: {
    enabled: true,
    measurementId: 'G-12YGVX7HQG'
  },
  consent: {
    provider: 'google-cmp'
  }
};

(function initializeSiteChrome() {
  const config = window.BOX_BUILDER_SITE || {};
  const ads = config.ads || {};
  const analytics = config.analytics || {};
  const consent = config.consent || {};
  const adSlots = document.querySelectorAll('[data-ad-slot]');
  const consentProvider = consent.provider || 'google-cmp';
  const analyticsEnabled = analytics.enabled === true
    && typeof analytics.measurementId === 'string'
    && analytics.measurementId.trim();

  function loadGoogleAnalytics() {
    if (!analyticsEnabled || window.__BOX_BUILDER_GTAG_LOADED__) return;
    const measurementId = analytics.measurementId.trim();
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(gaScript);
    window.__BOX_BUILDER_GTAG_LOADED__ = true;
  }

  adSlots.forEach((slot) => {
    const enabled = ads.enabled === true;
    slot.hidden = !enabled;
    if (!enabled) return;

    const copy = slot.querySelector('[data-ad-copy]');
    if (copy) {
      copy.textContent = ads.message || 'Advertisement';
    }
  });

  const yearEls = document.querySelectorAll('[data-current-year]');
  yearEls.forEach((el) => {
    el.textContent = String(new Date().getFullYear());
  });

  if (consentProvider === 'google-cmp') {
    loadGoogleAnalytics();
  }
}());